<section class="sub-header" [class.sub-header--leaderboard]="variant === 'leaderboard'">
  <div class="sub-header__wrapper grid place-items-center">
    <div class="sub-header__inner flex flex-col items-center">
      @if (badgeText) {
        <div class="sub-header__badge inline-flex items-center gap-2">
          @if (iconSrc) {
            <img [src]="iconSrc" alt="" class="sub-header__badge-icon" />
          }
          <span class="sub-header__badge-text">{{ badgeText }}</span>
        </div>
      }

      <h1 class="sub-header__title">{{ title }}</h1>

      <p class="sub-header__description">{{ description }}</p>
    </div>
  </div>
</section>
